import { Tabs } from '@base-ui-components/react/tabs'
import { Button, type ButtonProps } from '../primitives/button.js'
import { Close } from '@tunasong/icons'
import type { FC, Ref } from 'react'
import { IconButton } from '../primitives/index.js'

interface CustomTabProps extends Omit<ButtonProps, 'onChange'> {
  label: string
  value: string
  ref?: Ref<HTMLButtonElement>
  onClose: (value: string) => void
}

const CustomGroupTab: FC<CustomTabProps> = ({ onClose, label = 'Untitled', value, ref, ...restProps }) => (
  <Button
    ref={ref}
    style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: 4,
      cursor: 'pointer',
      fontSize: '0.875rem',
      borderRadius: 0,
      textTransform: 'none',
      backgroundColor: 'transparent',
      lineHeight: '1.2',
      border: 'none',
      justifyContent: 'center',
    }}
    {...restProps}
  >
    {label}
    <IconButton
      onClick={ev => {
        ev.stopPropagation()
        onClose?.(value)
      }}
      style={{ marginLeft: 8 }}
    >
      <Close size={12} />
    </IconButton>
  </Button>
)

const GroupTab = ({ value, ...props }: CustomTabProps) => (
  <Tabs.Tab value={value} render={<CustomGroupTab value={value} {...props} />} />
)

export const ContentGroupTab: FC<CustomTabProps> = GroupTab
